import React, { useEffect, useState, useRef } from "react";
import "./IftarQR.css";

const PHASE_IMAGES = {
  0: "/dist/img/iftarExchange.png",
  1: "/dist/img/iftarExchangePhase1.png",
  2: "/dist/img/iftarExchangePhase2.png",
};

const IftarQR = () => {
  const [imgSrc, setImgSrc] = useState(PHASE_IMAGES[0]);
  const previousPhaseRef = useRef(null);

  useEffect(() => {
    const fetchPhase = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_PATH_DESTINATION}/iftarExchangeGetPhaseStatus`);
        const data = await res.json();
        const currentPhase = Number(
          Array.isArray(data) ? data[0]?.phase_status : data?.phase_status ?? 0
        );

        // On first load, just set the image without reloading
        if (previousPhaseRef.current === null) {
          previousPhaseRef.current = currentPhase;
          setImgSrc(PHASE_IMAGES[currentPhase] ?? PHASE_IMAGES[0]);
          return;
        }

        // If phase changed, update image then reload the page
        if (previousPhaseRef.current !== currentPhase) {
          previousPhaseRef.current = currentPhase;
          setImgSrc(PHASE_IMAGES[currentPhase] ?? PHASE_IMAGES[0]);
          // Brief delay so the new image src is set before reload
          setTimeout(() => window.location.reload(), 300);
        }
      } catch (err) {
        console.error("Failed to fetch phase:", err);
      }
    };

    fetchPhase(); // initial
    const interval = setInterval(fetchPhase, 5000); // poll every 5s
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="qr-wrapper">
      <img
        src={imgSrc}
        alt="QR Code"
        className="qr-image"
      />
    </div>
  );
};

export default IftarQR;